import styled, { css } from 'styled-components';

export const Root = styled.button<{ $isConnected?: boolean }>`
  height: 32px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  ${({ $isConnected }) =>
    $isConnected
      ? css`
          background: rgba(155, 89, 182, 0.2);
          border-color: rgba(155, 89, 182, 0.35);
          color: rgba(255, 255, 255, 0.9);

          &:hover {
            background: rgba(231, 76, 60, 0.25);
            border-color: rgba(231, 76, 60, 0.4);
          }
        `
      : css`
          background: linear-gradient(135deg, rgba(155, 89, 182, 0.5), rgba(52, 152, 219, 0.5));
          border-color: transparent;
          color: #fff;

          &:hover {
            background: linear-gradient(135deg, rgba(155, 89, 182, 0.65), rgba(52, 152, 219, 0.65));
          }
        `}
`;

export const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2ecc71;
  flex-shrink: 0;
`;
